import './store-overlay.scss';

class StoreOverlay {
    constructor ($element, options) {
        const defaults = {
            initAttr: 'data-storeoverlay'
        };

        this.settings = Object.assign({}, defaults, options);
        this.$storeOverlay = $element;
        this.$tabsWrapper = this.$storeOverlay.querySelector(`[${this.settings.initAttr}="tabs"]`);
        this.$$tabs = this.$storeOverlay.querySelectorAll(`[${this.settings.initAttr}="tab"]`);
        this.$$targets = this.$storeOverlay.querySelectorAll(`[${this.settings.initAttr}="target"]`);
        this.$$logos = this.$storeOverlay.querySelectorAll(`[${this.settings.initAttr}="logo"]`);
        this.$tabNavigator = this.$storeOverlay.querySelector(`[${this.settings.initAttr}="navigator"]`);
        this.$activeTab = null;
        this.$unactiveTab = null;
        this.activeTabIndex = null;
        this.orderList = [];

        this.initialize();
    }

    initialize () {
        if (this.$$tabs.length > 0) {
            this.positionNavigator();
        }

        if (this.$$logos.length > 0) {
            for (let index = 0; index < this.$$logos.length; index++) {
                this.orderLogo(this.$$logos[index]);
            }
        }

        this.setEvents();
    }

    orderLogo (logo) {
        const order = Math.floor(Math.random() * (this.$$logos.length) + 1);

        if (this.orderList.indexOf(order) === -1) {
            this.orderList.push(order);
            logo.style.setProperty('--order', `${order}`);
        } else {
            this.orderLogo(logo);
        }
    }

    positionNavigator () {
        let left;
        let tabsWidth = 0;

        for (let index = 0; index < this.$$tabs.length; index++) {
            if (this.$$tabs[index].classList.contains('is--active')) {
                this.$activeTab = this.$$tabs[index];
                this.$activeTabIndex = index;
            } else {
                this.$unactiveTab = this.$$tabs[index];
            }
            tabsWidth += this.$$tabs[index].offsetWidth;
        }

        if (this.$activeTabIndex === 0) {
            left = `${(this.$tabsWrapper.offsetWidth - tabsWidth) / 4}px`;
        } else {
            left = `${(((this.$tabsWrapper.offsetWidth - tabsWidth) / 4) * 3) + this.$unactiveTab.offsetWidth}px`;
        }

        const width = this.$activeTab.offsetWidth;

        this.$tabNavigator.style.setProperty('--left', `${left}`);
        this.$tabNavigator.style.setProperty('--width', `${width}px`);
    }

    toggleContent () {
        for (let index = 0; index < this.$$tabs.length; index++) {
            if (this.$$tabs[index].classList.contains('is--active')) {
                this.$$tabs[index].classList.remove('is--active');
            } else {
                this.$$tabs[index].classList.add('is--active');
            }
        }

        for (let index = 0; index < this.$$targets.length; index++) {
            if (this.$$targets[index].classList.contains('is--active')) {
                this.$$targets[index].classList.remove('is--active');
            } else {
                this.$$targets[index].classList.add('is--active');
            }
        }

        this.positionNavigator();
    }

    setEvents () {
        if (this.$$tabs.length > 0) {
            this.$$tabs.forEach(tab => {
                tab.addEventListener('click', (e) => {
                    this.toggleContent();
                });
            });
        }
    }
}

export { StoreOverlay };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$storeOverlay = $context.querySelectorAll('[data-storeoverlay="root"]');
        for (let i = 0; i < $$storeOverlay.length; i++) {
            const $storeOverlay = $$storeOverlay[i];

            const storeOverlayAPI = new StoreOverlay($storeOverlay);
            $storeOverlay.API = storeOverlayAPI;
        }
    }
});
